import React from 'react';
import './PrivacyPolicy.css';

const PrivacyPolicy = () => {
  return (
    <div className="privacy-policy">
      <div className="privacy-container">
        <h1>Privacy Policy for JMI App</h1>
        <p><em>Last updated: November 12, 2025</em></p>
        <p>Thank you for using JMI App ("we," "our," or "us"), developed by JMI Group. We are committed to protecting your privacy and ensuring the security of your personal information. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our mobile application (the "App") for wholesale purchasing.</p>

        <h2>1. Information We Collect</h2>
        <p>We collect the following types of information to provide and improve our wholesale purchasing services:</p>
        <ul>
          <li><strong>Account Information:</strong> Full name, email address, phone number, and login credentials.</li>
          <li><strong>Business Details:</strong> Company name, GST number, business address, and trade license information.</li>
          <li><strong>Financial Information:</strong> Bank account details, UPI ID, and payment transaction history for processing wholesale orders.</li>
          <li><strong>Order Information:</strong> Purchase history, order details, and transaction records.</li>
          <li><strong>Location Data:</strong> For delivery and service area verification, with your explicit permission.</li>
          <li><strong>Device Information:</strong> Device model, operating system, and app usage data for analytics and support.</li>
        </ul>

        <h2>2. How We Use Your Information</h2>
        <p>We use your information to:</p>
        <ul>
          <li>Process and manage your wholesale orders and transactions</li>
          <li>Verify your business credentials and maintain your account</li>
          <li>Provide customer support and respond to inquiries</li>
          <li>Send order confirmations, invoices, and delivery updates</li>
          <li>Process payments and prevent fraudulent transactions</li>
          <li>Comply with legal and regulatory requirements</li>
          <li>Improve our services and develop new features</li>
          <li>Send promotional offers and business-related communications (you can opt-out anytime)</li>
        </ul>

        <h2>3. Data Security</h2>
        <p>We implement industry-standard security measures to protect your information:</p>
        <ul>
          <li>Data encryption in transit and at rest</li>
          <li>Secure payment processing through PCI-DSS compliant services</li>
          <li>Regular security audits and vulnerability assessments</li>
          <li>Restricted access to personal information on a need-to-know basis</li>
          <li>Secure authentication and authorization mechanisms</li>
        </ul>
        <p>While we strive to protect your information, no system can be completely secure. We encourage you to use strong passwords and keep your login credentials confidential.</p>

        <h2>4. Data Retention</h2>
        <p>We will retain your personal information only for as long as is necessary for the purposes set out in this Privacy Policy, or as required by law.</p>

        <h2>5. Information Sharing and Disclosure</h2>
        <p>We may share your information with:</p>
        <ul>
          <li><strong>Delivery Partners:</strong> Necessary delivery information to fulfill your orders</li>
          <li>Payment processors to complete transactions</li>
          <li>Legal and regulatory authorities when required by law</li>
          <li>Business partners for joint promotions (with your consent)</li>
          <li>In case of business transfers, such as mergers or acquisitions</li>
        </ul>
        <p>We require all third parties to respect your privacy and protect your information in accordance with applicable laws.</p>

        <h2>6. Your Data Protection Rights</h2>
        <p>Depending on your location, you may have certain rights regarding your personal information, including:</p>
        <ul>
          <li>The right to access, update, or delete your information</li>
          <li>The right to object to or restrict processing of your information</li>
          <li>The right to data portability</li>
          <li>The right to withdraw consent</li>
        </ul>

        <h2>7. Data Retention</h2>
        <p>We retain your information only as long as necessary to:</p>
        <ul>
          <li>Provide our services to you</li>
          <li>Comply with legal obligations</li>
          <li>Resolve disputes</li>
          <li>Enforce our agreements</li>
        </ul>
        <p>Financial records are retained for the period required by applicable tax and commercial laws.</p>

        <h2>8. Your Rights</h2>
        <p>You have the right to:</p>
        <ul>
          <li>Access and receive a copy of your personal data</li>
          <li>Rectify or update your information</li>
          <li>Request deletion of your data (subject to legal requirements)</li>
          <li>Object to or restrict processing of your data</li>
          <li>Withdraw consent (where applicable)</li>
          <li>Lodge a complaint with the relevant data protection authority</li>
        </ul>

        <h2>9. Changes to This Privacy Policy</h2>
        <p>We may update this Privacy Policy periodically. We will notify you of significant changes through the App or via email. Your continued use of the App after such changes constitutes acceptance of the updated policy.</p>

        <h2>10. Contact Us</h2>
        <p>If you have any questions about this Privacy Policy, please contact us at:</p>
        <p>
          In app support
          {/* Email: support@jmigroup.com<br /> */}
          {/* Address: JMI Group Headquarters, 123 Business District, New Delhi, India - 110001<br />
          Phone: +91-11-12345678 */}
        </p>
      </div>
    </div>
  );
};

export default PrivacyPolicy;